module.exports = __webpack_public_path__ + "img/5a.12fd9c78.png";